import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function DeclarationFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.declarationFilter.filter);

  const sortMessages = messages[lang].declarationFilterSort;

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_DECLARATION_FILTER',
      filter: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
      dispatch({
        type: 'GET_DECLARATIONS',
        page: 1,
			  filter: filters,
			  cleanTable: true
      })
    }
  }

  const statusFilter = [
    { id: "", message: messages[lang].all },
    { id: "1", message: "AGUARDANDO AVALIAÇÃO" },
    { id: "2", message: "APROVADO" },
    { id: "3", message: "REPROVADO" },
  ];

  const sortDeclaration = [
    { id: "pedido asc",        message: sortMessages.pedidoAsc},
    { id: "pedido desc",       message: sortMessages.pedidoDesc},   
    { id: "fornecedor asc",    message: sortMessages.fornecedorAsc},   
    { id: "fornecedor desc",   message: sortMessages.fornecedorDesc},   
    { id: "dataCadastro asc",  message: sortMessages.dataCadastroAsc},   
    { id: "dataCadastro desc", message: sortMessages.dataCadastroDesc},
  ];

  return (
    <Form className="px-3">
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].declarationListPage.numeroPedido}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].declarationListPage.numeroPedido}
                    type="text"
                    defaultValue={filters.pedido.id}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, pedido: { ...filters.pedido, id: event.target.value } },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].provider}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].provider}
                    type="text"
                    defaultValue={filters.fornecedor.nome}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, fornecedor: { ...filters.fornecedor, nome: event.target.value } },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].declarationListPage.status}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].declarationListPage.status}
                    type="text"
                    defaultValue={filters.declaracao.status}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, declaracao: { ...filters.declaracao, status: event.target.value } },
                    )}
                >
                {
                  statusFilter.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
              </Form.Control>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].declarationListPage.dtPedidoInicial}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].declarationListPage.dtPedidoInicial}
                    type="date"
                    defaultValue={filters.pedido.dataInicial}
                    onKeyUp={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, pedido: { ...filters.pedido, dataInicial: event.target.value } },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].declarationListPage.dtPedidoFinal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].declarationListPage.dtPedidoFinal}
                    type="date"
                    defaultValue={filters.pedido.dataFinal}
                    onKeyUp={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, pedido: { ...filters.pedido, dataFinal: event.target.value } },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].declarationListPage.dtCadastroInicial}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].declarationListPage.dtCadastroInicial}
                    type="date"
                    defaultValue={filters.declaracao.dataInicial}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, declaracao: { ...filters.declaracao, dataInicial: event.target.value } },
                    )}
                />
        </Form.Group>
        
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{messages[lang].declarationListPage.dtCadastroFinal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={messages[lang].declarationListPage.dtCadastroFinal}
                    type="date"
                    defaultValue={filters.declaracao.dataFinal}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, declaracao: { ...filters.declaracao, dataFinal: event.target.value } },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{sortMessages.sortBy}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={sortMessages.sortBy}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                    { ...filters, orderBy: event.target.value },
                    )}
                >
                {
                  sortDeclaration.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>
      </Row>
    </Form>
  );
}
